<template>
    <el-card v-loading="loading">
        <template slot="header">
            编辑dy_log
        </template>
        <el-form :model="dy_log"
                 :rules="rules"
                 ref="ruleForm"
                 label-position="right"
                 label-width="80px">
                                                                                                                    <el-form-item label="level" prop="level">
        <el-input v-model="DyLog.level"></el-input>
      </el-form-item>
                                                                                                                            <el-form-item label="msg" prop="msg">
        <el-input v-model="DyLog.msg" type="textarea"></el-input>
      </el-form-item>
                                                                                                                            <el-form-item label="ext_type" prop="ext_type">
        <el-input v-model="DyLog.ext_type"></el-input>
      </el-form-item>
                                                                                                                            <el-form-item label="ext_id" prop="ext_id">
    <el-input-number v-model="DyLog.ext_id"></el-input-number>
</el-form-item>
                                                                                                                            <el-form-item label="collection" prop="collection">
        <el-input v-model="DyLog.collection"></el-input>
      </el-form-item>
                                                                                                                            <el-form-item label="input" prop="input">
        <el-input v-model="DyLog.input" type="textarea"></el-input>
      </el-form-item>
                                                                                                                            <el-form-item label="user" prop="user">
        <el-input v-model="DyLog.user"></el-input>
      </el-form-item>
                                                                                                        
            <el-form-item>
                <el-button type="primary" @click="update('ruleForm')">保存</el-button>
                <el-button type="success" @click="back">返回</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
    import {mapState} from 'vuex'
    import '@/static/test'
                                                                                                                                
    export default {
        name: "DyLogEdit",
        props: {
            id: {
                required: true
            }
        },
        components: {
                                                                                                                                                                                                                                                                    },
        data() {
            return {
            dy_log:{}
            }
        },
        computed: {
            ...mapState({
                DyLog: state => state.dy_log.DyLog,
                rules: state => state.dy_log.rules,
                loading: state => state.dy_log.loading
            })
        },
        methods: {
            back() {
                this.$router.back();
            },
            update(form) {
                let vthis = this;

                this.$refs[form].validate((validate) => {
                    if (!validate) {
                        return;
                    }
                    this.$store.dispatch('dy_log/update').then(res => {
                        vthis.$confirm('是否关闭页面?')
                            .then(_ => {
                                vthis.$router.back();
                            });
                    })
                        .catch(res =>{
                            console.log(res);
                        });
                });

            }
        },
        created() {
            this.$store.dispatch('dy_log/show', {id: this.id});
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/dy_log/DyLogEdit.vue